import { OnboardingFlowIdentifier } from '@Types/onboarding.types.ts';
import { RoutesMap } from '@Router/router.types.ts';
import { useBoundStore } from '@Store/index';
import { AuthorizedUserType } from '@Store/slices/authOnboarding/authOnboarding.types';

const defaultStack = [
  RoutesMap.WELCOME,
  RoutesMap.PERSONAL_DETAILS,
  RoutesMap.PHONE,
  RoutesMap.IDENTITY,
  RoutesMap.HOME_ADDRESS,
  RoutesMap.BUSINESS_TYPE_SELECTION,
  RoutesMap.INDUSTRY,
  RoutesMap.KNOW_YOUR_BUSINESS,
  RoutesMap.BUSINESS_ADDRESS,
  RoutesMap.OWNER_CENTER,
  RoutesMap.PLAN_SELECTION,
  RoutesMap.ACCOUNT_OPENING_REASON,
  RoutesMap.REVIEW,
];

const _getAuthorizedUserStack = (authorizedUserType: AuthorizedUserType) => {
  switch (authorizedUserType) {
    case AuthorizedUserType.ACCOUNTANT:
      return [
        RoutesMap.INVITE_TEAM_MEMBER_INTRO,
        RoutesMap.INVITE_ACCOUNTANT_FORM,
        RoutesMap.VERIFY_PHONE_NUMBER,
        RoutesMap.SET_PASSWORD,
        RoutesMap.INVITE_TEAM_MEMBER_FINISHED,
      ];
    case AuthorizedUserType.ADMIN:
      return [
        RoutesMap.INVITE_TEAM_MEMBER_INTRO,
        RoutesMap.INVITE_ADMIN_FORM,
        RoutesMap.VERIFY_PHONE_NUMBER,
        RoutesMap.SET_PASSWORD,
        RoutesMap.INVITE_TEAM_MEMBER_FINISHED,
      ];
    default:
      return defaultStack;
  }
};

const _getPartnerEmbeddedStack = () => [
  RoutesMap.WELCOME,
  RoutesMap.PHONE,
  RoutesMap.IDENTITY,
  RoutesMap.HOME_ADDRESS,
  RoutesMap.BUSINESS_TYPE_SELECTION,
  RoutesMap.INDUSTRY,
  RoutesMap.KNOW_YOUR_BUSINESS,
  RoutesMap.BUSINESS_ADDRESS,
  RoutesMap.OWNER_CENTER,
  RoutesMap.PLAN_SELECTION,
  RoutesMap.ACCOUNT_OPENING_REASON,
  RoutesMap.REVIEW,
];

const _getPartnerConnect = () => [
  RoutesMap.WELCOME,
  RoutesMap.PHONE,
  RoutesMap.IDENTITY,
  RoutesMap.HOME_ADDRESS,
  RoutesMap.BUSINESS_TYPE_SELECTION,
  RoutesMap.INDUSTRY,
  RoutesMap.KNOW_YOUR_BUSINESS,
  RoutesMap.BUSINESS_ADDRESS,
  RoutesMap.OWNER_CENTER,
  RoutesMap.PLAN_SELECTION,
  RoutesMap.ACCOUNT_OPENING_REASON,
  RoutesMap.REVIEW,
];

const _getDirectMultiBusiness = () => [
  RoutesMap.BUSINESS_TYPE_SELECTION,
  RoutesMap.INDUSTRY,
  RoutesMap.KNOW_YOUR_BUSINESS,
  RoutesMap.BUSINESS_ADDRESS,
  RoutesMap.OWNER_CENTER,
  RoutesMap.PLAN_SELECTION,
  RoutesMap.ACCOUNT_OPENING_REASON,
  RoutesMap.REVIEW,
];

export const getNavigationStackMap = (): RoutesMap[] => {
  const { onboardingFlowIdentifier } = useBoundStore.getState().onboardingSlice.getOnboardingData();
  const authUserType = useBoundStore.getState().getAuthUserType();

  switch (onboardingFlowIdentifier) {
    case OnboardingFlowIdentifier.DIRECT:
      return defaultStack;

    case OnboardingFlowIdentifier.PARTNER_EMBEDDED:
      return _getPartnerEmbeddedStack();

    case OnboardingFlowIdentifier.PARTNER_CONNECT:
      return _getPartnerConnect();

    case OnboardingFlowIdentifier.DIRECT_MULTI_BUSINESS:
      return _getDirectMultiBusiness();

    // @TODO ADD UBOs
    case OnboardingFlowIdentifier.UBO:
      return [];

    case OnboardingFlowIdentifier.AUTHORIZED_USER:
      return _getAuthorizedUserStack(authUserType);

    default:
      return defaultStack;
  }
};
